import {
    ICaptcha,
    INewReport,
    IReportExtended,
    ISimilarReport,
    ISMResponse,
    ISMResponseSuccess,
} from '../models';
import api from './api';

export class ReportService {
    report: Partial<INewReport> = {};
    similarReport: ISimilarReport | null = null;

    constructor(localization: Pick<INewReport, 'localization'>) {
        this.report = { ...this.report, ...localization };
    }

    setEmailAuthorization(email: string): void {
        this.report = { ...this.report, email: email };
    }

    createReport(report: Omit<INewReport, 'attachments' | 'email' | 'localization'>): void {
        this.report = { ...this.report, ...report };
    }

    async findSimilarReport(report: Pick<INewReport, 'category'>): Promise<ISimilarReport | null> {
        const response = await api.get(
            `reports/similar?category=${report.category}&place[lon]=${this.report.localization?.lon}&place[lat]=${this.report.localization?.lat}`,
        );
        const responseJSON = (await response.json()) as ISMResponseSuccess<{
            report: ISimilarReport | null;
        }>;

        this.similarReport = responseJSON.data.report;
        return this.similarReport;
    }

    async uploadFiles(files: File[]) {
        if (files.length === 0) return;
        const response = await api.cdnGet('auth');
        const auth = (await response.json()) as ISMResponse<{ token: { id: string } }>;
        if (auth.status === 'error') {
            return;
        }

        const formData = new FormData();
        for (const file of files) {
            formData.append('photos', file);
        }
        const photosResponse = await api.cdnPost('files/upload', {
            body: formData,
            headers: { Authorization: auth.data.token.id },
        });
        const filesResponse = (await photosResponse.json()) as ISMResponse<{
            attachments: string[];
        }>;
        if (filesResponse.status === 'success') {
            this.report = { ...this.report, attachments: filesResponse.data.attachments };
        }
    }

    async send(
        captchaToken: string,
    ): Promise<
        { success: true; data: IReportExtended } | { success: false; error: 2061 | 2071 | 2050 }
    > {
        const reportValidFormat = {
            ...this.report,
            category: this.report.category?.toString(),
            attachments: this.report.attachments ? this.report.attachments : [],
            captcha: {
                version: 3,
                token: captchaToken,
            } as ICaptcha,
        };
        const response = await api.post('reports', { body: JSON.stringify(reportValidFormat) });
        const report = (await response.json()) as ISMResponse<{ report: IReportExtended }>;
        if (report.status === 'success') {
            return { success: true, data: report.data.report };
        } else {
            return { success: false, error: report.data.errors[0].code as 2061 | 2071 | 2050 };
        }
    }
}
